import makeStyles from '@material-ui/core/styles/makeStyles';
import { lighten, darken, alpha } from '@material-ui/core';
import clsx from 'clsx';

import { ROW_HEIGHT } from './Constants';

const useResultRowStyles = makeStyles((theme) => ({
    root: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionColumn,
        ...theme.mixins.flex.justifyContentCenter,

        padding: theme.spacing(0, 2),
        height: ROW_HEIGHT,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',

        '&.layout-row': {
            ...theme.mixins.flex.flexDirectionRow,
            ...theme.mixins.flex.justifyContentFlexStart,
            ...theme.mixins.flex.alignItemsCenter,
        },

        '&.hoverable': {
            '&:hover': {
                backgroundColor:
                    theme.palette.type === 'light'
                        ? darken(alpha(theme.palette.background.paper, 1), 0.03)
                        : lighten(alpha(theme.palette.background.paper, 1), 0.06),
            },
        },

        '&.clickable': {
            cursor: 'pointer',
        },
    },

    title: {
        ...theme.mixins.flex.grow(1),
        ...theme.typography.subtitle2,

        paddingLeft: theme.spacing(1),
    },
}));

export default function ResultRow(props) {
    const { hoverable, clickable, rowLayout, children, className } = props;
    const classes = useResultRowStyles();

    const rowClasses = {
        hoverable,
        clickable,
        'layout-row': rowLayout,
    };

    return <div className={clsx(className, classes.root, rowClasses)}>{children}</div>;
}
